import React, { HTMLAttributes } from "react";
import classnames from "classnames";

import Placeholder, { Rect } from "components/Placeholder";

const MenuItemCardPlaceholder: React.FC<
  {
    /**
     * Optional className to apply to the card container
     */
    className?: string;
    /**
     * Whether to show additional placeholder section for order actions
     */
    showOrderActions?: boolean;
  } & HTMLAttributes<HTMLDivElement>
> = ({ className, showOrderActions = true, ...others }) => {
  return (
    <div
      className={classnames(
        "flex flex-col justify-between relative h-full w-full bg-white elevation-low rounded p-lg pt-xl",
        className
      )}
      {...others}
    >
      <div className="h-full w-full">
        <Placeholder className="mx-auto" width="112" height="112">
          <Rect width="100%" height="100%" />
        </Placeholder>
        <Placeholder width="60" height="12" className="mt-md">
          <Rect width="100%" height="100%" />
        </Placeholder>
        <Placeholder width="100%" height="22" className="mt-xs">
          <Rect width="100%" height="100%" />
        </Placeholder>
        <Placeholder width="60%" height="12" className="mt-xs">
          <Rect width="100%" height="100%" />
        </Placeholder>
        <div className="flex mt-md">
          <Placeholder width="65" height="12" className="mr-sm">
            <Rect width="100%" height="100%" />
          </Placeholder>
          <Placeholder width="65" height="12">
            <Rect width="100%" height="100%" />
          </Placeholder>
        </div>
        <Placeholder width="110" height="14" className="mt-md">
          <Rect width="100%" height="100%" />
        </Placeholder>
      </div>
      <div className="mt-xs">
        <Placeholder width="40" height="12">
          <Rect width="100%" height="100%" />
        </Placeholder>
        <Placeholder width="90" height="22" className="mt-sm">
          <Rect width="100%" height="100%" />
        </Placeholder>
        {showOrderActions && (
          <Placeholder width="100%" height="36" className="mt-md">
            <Rect width="100%" height="100%" rx="16" ry="16" />
          </Placeholder>
        )}
      </div>
    </div>
  );
};

export default MenuItemCardPlaceholder;
